import { DifferentiationProps } from '@zola/zola-ui/src/components/PreAuthV3/Differentiation';
import COLORS from '@zola/zola-ui/src/styles/emotion/colors3';
import NextBackgroundForegroundImages from 'components/PreauthV3/NextBackgroundForegroundImages';
import { differentiationStyleOverrides } from 'components/PreauthV3/NextBackgroundForegroundImages/NextBackgroundForegroundImages.styles';

const InstantRegistryDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Differentation/Desktop/InstantRegistry.png';
const DiscountDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Differentation/Desktop/Discount.png';
const GroupGiftingDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Differentation/Desktop/GroupGifting.png';
const ShippingDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Differentation/Desktop/Shipping.png';
const SupportDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Differentation/Desktop/Support.png';
const ThankYouDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Differentation/Desktop/ThankYou.png';

export const differentiationContentAlt: DifferentiationProps['content'] = [
  {
    id: 'instant-registry',
    subtitle: 'Instant registry',
    description:
      'With one click, we’ll add our most popular picks to your registry. You decide what to keep and what else to add.',
    imageElement: (
      <NextBackgroundForegroundImages
        bgColor={COLORS.MARINE_100}
        foregroundImg={{
          src: InstantRegistryDesktop,
          alt: 'Screenshot of our most popular picks that will be instantly added to your registry.',
          objectFit: 'cover',
        }}
        priority={false}
        css={differentiationStyleOverrides}
      />
    ),
  },
  {
    id: 'discount',
    subtitle: '20% Newlywed Discount after your wedding',
    description:
      "Save big after the big day, with 20% off anything that's still on your registry. The best part? You can use our Newlywed Discount as many times as you like, for six months. Think of it as a wedding gift from everyone at Zola — and the perfect start to newlywed life.",
    imageElement: (
      <NextBackgroundForegroundImages
        bgColor={COLORS.BAY_100}
        foregroundImg={{
          src: DiscountDesktop,
          alt: 'Screenshot of a sample wedding registry website, featuring Samsonite carry-on luggage, Estelle colored glasses, and a Caraway Home fry pan.',
        }}
        priority={false}
        css={differentiationStyleOverrides}
      />
    ),
  },
  {
    id: 'group-gifting',
    subtitle: 'Group gifting',
    description:
      'Got your eyes on a big ticket item? Group gifting allows multiple guests to chip in. Think big: a dining table, couch, outdoor furniture, kitchen appliances, or a complete cookware set. Or upgrade your gadgets and technology.',
    imageElement: (
      <NextBackgroundForegroundImages
        bgColor={COLORS.WINE_100}
        foregroundImg={{
          src: GroupGiftingDesktop,
          alt: 'Screenshot of a sample honeymoon fund on Zola.',
        }}
        priority={false}
        css={differentiationStyleOverrides}
      />
    ),
  },
  {
    id: 'shipping',
    subtitle: 'Ship when you want',
    description:
      "Want them now or after you're back from your honeymoon? You're in control of when gifts ship. And if you change your mind between now and then, that's fine — exchange your gifts before they ship or convert to credit.",
    imageElement: (
      <NextBackgroundForegroundImages
        bgColor={COLORS.ROSE_100}
        foregroundImg={{
          src: ShippingDesktop,
          alt: '',
        }}
        priority={false}
        css={differentiationStyleOverrides}
      />
    ),
  },
  {
    id: 'support',
    subtitle: 'Help from Team-Z (for you and your guests!)',
    description:
      "Not sure what to register for? Need help with thank you cards? Our expert advisors are here to help and offer support, encouragement, advice and answer all your questions. They've heard it all, so don't be shy! And Team-Z are here to help your guests with all their questions, too!",
    imageElement: (
      <NextBackgroundForegroundImages
        bgColor={COLORS.FOREST_100}
        foregroundImg={{
          src: SupportDesktop,
          alt: 'Screenshot of a chat with a wedding expert on how to build a wedding registry.',
        }}
        priority={false}
        css={differentiationStyleOverrides}
      />
    ),
  },
  {
    id: 'thank-you',
    subtitle: 'Thank you note manager',
    description:
      "We'll keep track of who bought what and even help with what to write. And if you have messy handwriting, we'll print your messages in a beautiful font. Plus, you'll get all our paper perks — free envelopes, free addressing, and free shipping.",
    imageElement: (
      <NextBackgroundForegroundImages
        bgColor={COLORS.MARINE_100}
        foregroundImg={{
          src: ThankYouDesktop,
          alt: '',
        }}
        priority={false}
        css={differentiationStyleOverrides}
      />
    ),
  },
];
